interface SkillSelectorProps {
  selected: string[];
  onChange: (skills: string[]) => void;
  skills: string[];
}

export function SkillSelector({ selected, onChange, skills }: SkillSelectorProps) {
  const toggle = (skill: string) => {
    if (selected.includes(skill)) {
      onChange(selected.filter((s) => s !== skill));
    } else {
      onChange([...selected, skill]);
    }
  };

  return (
    <div className="skill-grid">
      {skills.map((skill) => (
        <label
          key={skill}
          className={`skill-chip${selected.includes(skill) ? ' selected' : ''}`}
          onClick={() => toggle(skill)}
        >
          <input
            type="checkbox"
            checked={selected.includes(skill)}
            onChange={() => toggle(skill)}
          />
          {skill}
        </label>
      ))}
    </div>
  );
}
